document.addEventListener('DOMContentLoaded', function() {
  // Fisher-Yates shuffle algorithm
  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  // Randomize dealer items within each grid
  function randomizeDealerGrid(gridElement) {
    if (!gridElement) return;
    
    const dealerItems = gridElement.querySelectorAll('.dealer-item');
    if (dealerItems.length === 0) return;
    
    const itemsArray = Array.from(dealerItems);
    const shuffledItems = shuffleArray(itemsArray);
    
    // Re-append items in randomized order
    shuffledItems.forEach(item => {
      gridElement.appendChild(item);
    });
  }

  // Find all dealer grids and randomize them
  const dealerGrids = document.querySelectorAll('[data-randomize-dealers]');
  dealerGrids.forEach(grid => {
    randomizeDealerGrid(grid);
  });
});

